import React from 'react';
import { Modal } from '@/components';
import { SendMessageFlow } from './send-message-flow';

interface SendMessageModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const SendMessageModal: React.FC<SendMessageModalProps> = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <SendMessageFlow onSuccess={() => setTimeout(() => onClose(), 4000)} />
    </Modal>
  );
};
